export default __webpack_public_path__ + "static/media/27.a2e949d5.png";